import React from 'react';
import PropTypes from 'prop-types';

import { getFormattedPhoneNumber } from 'utils/v2';
import { getCamelCaseFormattedAddress } from '../../../../utils/helpers';
import { StyledTypography, StyledPrefix } from './Text.styles';

const formatters = {
  camelCase: getCamelCaseFormattedAddress,
  phoneNumber: getFormattedPhoneNumber,
};

export const Text = (props, formatter, settings, prefix) => {
  let value;
  if (typeof props === 'string') {
    value = props;
  } else if (
    typeof props === 'object' &&
    props !== null &&
    typeof props.cell.value !== 'string'
  ) {
    value = props.cell.value && Object.values(props.cell.value).join(' ');
  } else if (typeof props.cell.value === 'string') {
    value = props.cell.value;
  } else {
    value = 'N/A';
  }

  if (formatter && Object.keys(formatters).includes(formatter)) {
    value = formatters[formatter](value);
  }

  return (
    <StyledTypography $settings={settings}>
      {prefix && <StyledPrefix>{prefix}</StyledPrefix>}
      {value}
    </StyledTypography>
  );
};

Text.propTypes = {
  cell: PropTypes.object,
};
